import React, { Dispatch, ReactNode, SetStateAction } from 'react';

import { Dialog } from '@mui/material';

interface Props {
  children: ReactNode;
  fullScreen?: boolean;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  scroll?: 'body' | 'paper';
  handleOnClose?: () => void;
}
export default function BasicDialog({
  children,
  fullScreen = false,
  fullWidth = false,
  maxWidth = 'sm',
  isOpen,
  setIsOpen,
  scroll,
  handleOnClose,
}: Props) {
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={isOpen}
      onClose={() => {
        handleOnClose && handleOnClose();
        setIsOpen(false);
      }}
      scroll={scroll}
    >
      {children}
    </Dialog>
  );
}
